import React from "react";
import Page from "../../Page";
import { GalleryError } from "../../partials/GalleryError";

const WebGalleryError: React.FunctionComponent = () => {
  return (
    <Page>
      <GalleryError />
    </Page>
  );
};

export default WebGalleryError;
